import {NgModule} from '@angular/core'
import {PartnersComponent} from './partners.component'
import {CommonModule} from '@angular/common'
import {ContentSectionModule} from '../content-section/content-section.module'
import {RouterModule} from '@angular/router'
import {SliderModule} from '../slider/slider.module'
import {CardsModule} from '../cards/cards.module'
import {I18nDirective} from '../i18n/i18n.directive'

@NgModule({
  declarations: [PartnersComponent],
  imports: [CommonModule, ContentSectionModule, RouterModule, SliderModule, CardsModule, I18nDirective],
  exports: [PartnersComponent],
})
export class PartnersModule {}
